 <template>
  <!-- 画布元素-->
  <div id="container"></div>
</template>
 <script>
import * as THREE from "three"; //3D基础类
import { OBJLoader } from "three/examples/jsm/loaders/OBJLoader"; //导入外部辅组obj模型类

//xyz对应的坐标轴  红绿蓝 rgb
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls"; //轨道控制器  随着随便放大 缩小

export default {
  //变量申明模块
  data() {
    return {
      renderer: null, //渲染器
      // loader, //纹理加载器
      scene: null, //场景
      camera: null, //相机
      controls: null, //轨道控制器
      mesh: null, //网格
      meshgroup: null,
    };
  },
  //方法申明模块
  methods: {
    init: function () {
      //渲染器
      this.renderer = new THREE.WebGLRenderer({
        //增加下面两个属性，可以抗锯齿
        antialias: true,
        alpha: true,
      });

      /*-- 设置渲染器背景颜色--*/
      //颜色背景 灰  背景矩形旋转大小  556 *500
      // this.renderer.setClearColor("rgb(242,242,242)", 1.0);
      //颜色背景 翡翠
      //  this.renderer.setClearColor("rgb(241,243,241)", 1.0);

      //设置渲染器高度与宽度
      var inWidth = window.innerWidth;
      var inHeight = window.innerHeight;

      this.renderer.setSize(inWidth, inHeight);
      //渲染器加入到网页BODY里面去
      // document.body.appendChild(this.renderer.domElement);
      let container = document.getElementById("container");
      container.appendChild(this.renderer.domElement);
      let loader = new THREE.TextureLoader();
      let bgTexture = loader.load("/comom/bluebg.png");

      //场景
      this.scene = new THREE.Scene();
      this.scene.background = bgTexture;
      //相机
      this.camera = new THREE.PerspectiveCamera(
        75,
        inWidth / inHeight,
        0.1,
        1000
      );
      //相机的位置
      this.camera.position.x = 0;
      //设置相机的高度
      this.camera.position.y = 1.1795;
      //设置相机的相对于看到的距离
      this.camera.position.z = 5;
      //实例化轨道控制器 必须实例化在 相机和渲染器后面
      this.controls = new OrbitControls(this.camera, this.renderer.domElement);

      // 创建一个矩形平面几何体，宽度100，长度200
      var plane = new THREE.PlaneGeometry(7, 7);

      let texturefloor = loader.load(
        "/batamancar/internal_ground_ao_texture.jpeg"
      );

      let materialplan = new THREE.MeshPhongMaterial({
        // 矩形平面网格模型默认单面显示，可以设置side属性值为THREE.DoubleSide双面显示
        //side: THREE.DoubleSide,
        map: texturefloor,
        // transparent设置为true，开启透明，否则opacity不起作用
        transparent: true,
        // 设置材质透明度
        opacity: 0,
      });

      //平面出来 默认是水平面 需要向X轴 旋转弧度
      plane.rotateX(-1.570796);

      this.mesh = new THREE.Mesh(plane, materialplan);
      this.scene.add(this.mesh);
      //加入光源
      var pointLight = new THREE.PointLight("#ffffff");
      //光源坐标
      pointLight.position.set(0, 10, 10);
      this.scene.add(pointLight);
      // 辅助坐标系  参数200表示坐标系大小，可以根据场景大小去设置
      var axesHelper = new THREE.AxesHelper(200);
      this.scene.add(axesHelper);
      //必须在对相机的变换进行任何手动更改后调用
      this.controls.update();

      //obj导入类

      let objloader = new OBJLoader();

      
      var that = this;
      this.meshgroup = new THREE.Group();

      objloader.load("/batamancar/bataman-car.obj", function (object) {
        //模型的x、y、z轴的位置

        object.position.set(0.03817, 0, -0.30002003);
        //缩放比列
        object.scale.set(1.5, 1.5, 1.5);

        object.traverse(function (child) {
          if (child instanceof THREE.Mesh) {
            debugger;
            //设置模型皮肤
            child.material.map = THREE.ImageUtils.loadTexture(
              "/batamancar/b_Front_color.jpg"
            );
          }
        });

        that.meshgroup = object;
        that.scene.add(object);
      });
 
    },
    onWindowResize: function () {
      this.renderer.setSize(window.innerWidth, window.innerHeight);
    },
    animate: function () {
      requestAnimationFrame(this.animate);
      //如果controls.enableDamping 或controls.autoRotate 设置为true，则需要
      this.controls.update();

      this.renderer.render(this.scene, this.camera);

      this.meshgroup.rotation.y += 0.01;
    },
  },
  //模板渲染成html后调用，通常是初始化页面完成后，再对html的dom节点进行一些需要的操作
  mounted() {
    this.init();
    this.animate();

    window.addEventListener("resize", () => this.onWindowResize(), false);
  },
};
</script>

